import { InfoCircle, TickCircle } from 'iconsax-reactjs';
import type { FC, ReactNode } from 'react';
import { cn } from './react';

export type BadgeProps = {
  className?: string;
  size: 4 | 5 | 6 | 8;
  variant:
    | 'positive'
    | 'positive_bold'
    | 'notice'
    | 'notice_bold'
    | 'negative'
    | 'negative_bold'
    | 'gray'
    | 'primary'
    | 'primary_bold';
  children?: ReactNode;
  fab?: boolean;
  icon?: boolean;
};

export const Badge: FC<BadgeProps> = ({
  className,
  size,
  variant,
  children,
  fab,
  icon,
}) => (
  <span
    className={cn(
      'inline-flex gap-1 items-center font-normal whitespace-nowrap justify-center border',
      size === 4 && ['h-4 rounded-full text-2xs', fab ? 'w-4' : 'px-1'],
      size === 5 && ['h-5 rounded-full text-2xs', fab ? 'w-5' : 'px-2'],
      size === 6 && ['h-6 rounded-full text-xs', fab ? 'w-6' : 'px-2'],
      size === 8 && ['h-8 rounded-full text-xs', fab ? 'w-8' : 'px-2'],
      variant === 'notice' &&
        'bg-background-notice/10 text-content-notice border-transparent',
      variant === 'notice_bold' &&
        'bg-background-notice text-shades-white-100 border-transparent',
      variant === 'positive' &&
        'bg-background-positive/10 text-content-positive border-transparent',
      variant === 'positive_bold' &&
        'bg-background-positive text-shades-white-100 border-transparent',
      variant === 'negative' &&
        'bg-background-negative/10 text-content-negative border-transparent',
      variant === 'negative_bold' &&
        'bg-background-negative text-shades-white-100 border-transparent',
      variant === 'primary' &&
        'border-border-disabled bg-background-disabled text-content-primary',
      variant === 'primary_bold' &&
        'bg-background-inverse text-content-primary-inverse border-transparent',
      variant === 'gray' &&
        'bg-background-disabled/60 text-content-secondary border-transparent',
      className,
    )}
  >
    {icon &&
      (variant === 'positive' || variant === 'positive_bold' ? (
        <TickCircle variant="Bold" size={14} />
      ) : variant === 'negative' ||
        variant === 'negative_bold' ||
        variant === 'notice' ? (
        <InfoCircle variant="Bold" size={14} />
      ) : null)}
    {children}
  </span>
);
